import React, { useEffect, useState } from "react";

import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Typography,
  Divider,
} from "@mui/material";

import {
  DashboardOutlined,
  GroupsOutlined,
  PointOfSaleOutlined,
  ShoppingCartOutlined,
  ReceiptLongOutlined,
  AccountBalanceWalletOutlined,
  FolderOutlined,
  SupportAgentOutlined,
  BarChartOutlined,
  SettingsOutlined,
  ExpandLess,
  ExpandMore,
  PersonSearchOutlined,
  FollowTheSignsOutlined,
  DescriptionOutlined,
  PaymentsOutlined,
  StorefrontOutlined,
  RequestQuoteOutlined,
  BusinessOutlined,
  CalendarMonthOutlined,
  CategoryOutlined,
  AccountCircleOutlined,
} from "@mui/icons-material";

import {
  useLocation,
  useNavigate,
} from "react-router-dom";

import logo from "../../assets/images/praneesh-infotech-logo.png";

/* =========================================================
   DRAWER WIDTH
========================================================= */

const drawerWidth = 260;

/* =========================================================
   MENU ITEMS
========================================================= */

const menuItems = [
  /* =======================================================
     DASHBOARD
  ======================================================= */

  {
    title: "Dashboard",
    icon: <DashboardOutlined />,
    path: "/dashboard",
  },

  /* =======================================================
     CRM
  ======================================================= */

  {
    title: "CRM",
    icon: <GroupsOutlined />,
    children: [
      {
        title: "Leads",
        icon: <PersonSearchOutlined />,
        path: "/crm/leads",
      },
      {
        title: "Follow-ups",
        icon: <FollowTheSignsOutlined />,
        path: "/crm/follow-ups",
      },
      {
        title: "Customers",
        icon: <GroupsOutlined />,
        path: "/crm/customers",
      },
      {
        title: "Activities",
        icon: <CalendarMonthOutlined />,
        path: "/crm/activities",
      },
    ],
  },

  /* =======================================================
     SALES
  ======================================================= */

  {
    title: "Sales",
    icon: <PointOfSaleOutlined />,
    children: [
      {
        title: "Quotations",
        icon: <RequestQuoteOutlined />,
        path: "/sales/quotations",
      },
      {
        title: "Sales Orders",
        icon: <DescriptionOutlined />,
        path: "/sales/orders",
      },
      {
        title: "Invoices",
        icon: <ReceiptLongOutlined />,
        path: "/sales/invoices",
      },
      {
        title: "Receipts",
        icon: <PaymentsOutlined />,
        path: "/sales/receipts",
      },
      {
        title: "Credit Notes",
        icon: <DescriptionOutlined />,
        path: "/sales/credit-notes",
      },
      {
        title: "Debit Notes",
        icon: <DescriptionOutlined />,
        path: "/sales/debit-notes",
      },
      {
        title: "Customer Payments",
        icon: <AccountBalanceWalletOutlined />,
        path: "/sales/payments",
      },
      {
        title: "Receivables",
        icon: <AccountBalanceWalletOutlined />,
        path: "/sales/receivables",
      },
    ],
  },

  /* =======================================================
     PURCHASE
  ======================================================= */

  {
    title: "Purchase",
    icon: <ShoppingCartOutlined />,
    children: [
      {
        title: "Vendors",
        icon: <StorefrontOutlined />,
        path: "/purchase/vendors",
      },
      {
        title: "Purchase Bills",
        icon: <ReceiptLongOutlined />,
        path: "/purchase/bills",
      },
      {
        title: "Purchase Returns",
        icon: <DescriptionOutlined />,
        path: "/purchase/returns",
      },
      {
        title: "Vendor Payments",
        icon: <PaymentsOutlined />,
        path: "/purchase/payments",
      },
      {
        title: "Payables",
        icon: <AccountBalanceWalletOutlined />,
        path: "/purchase/payables",
      },
    ],
  },

  /* =======================================================
     EXPENSES
  ======================================================= */

  {
    title: "Expenses",
    icon: <AccountBalanceWalletOutlined />,
    path: "/expenses",
  },

  /* =======================================================
     PROJECTS
  ======================================================= */

  {
    title: "Projects",
    icon: <FolderOutlined />,
    children: [
      {
        title: "Projects",
        icon: <FolderOutlined />,
        path: "/projects",
      },
      {
        title: "Tasks",
        icon: <DescriptionOutlined />,
        path: "/projects/tasks",
      },
      {
        title: "Milestones",
        icon: <CategoryOutlined />,
        path: "/projects/milestones",
      },
    ],
  },

  /* =======================================================
     SUPPORT
  ======================================================= */

  {
    title: "Support",
    icon: <SupportAgentOutlined />,
    children: [
      {
        title: "Tickets",
        icon: <SupportAgentOutlined />,
        path: "/support/tickets",
      },
      {
        title: "AMC",
        icon: <BusinessOutlined />,
        path: "/support/amc",
      },
      {
        title: "Renewals",
        icon: <CalendarMonthOutlined />,
        path: "/support/renewals",
      },
    ],
  },

  /* =======================================================
     REPORTS
  ======================================================= */

  {
    title: "Reports",
    icon: <BarChartOutlined />,
    children: [
      {
        title: "Sales Report",
        path: "/reports/sales",
      },
      {
        title: "Purchase Report",
        path: "/reports/purchase",
      },
      {
        title: "Expense Report",
        path: "/reports/expenses",
      },
      {
        title: "Payment Report",
        path: "/reports/payments",
      },
      {
        title: "GST Report",
        path: "/reports/gst",
      },
      {
        title: "Profit & Loss",
        path: "/reports/profit-loss",
      },
    ],
  },

  /* =======================================================
     MASTERS
  ======================================================= */

  {
    title: "Masters",
    icon: <CategoryOutlined />,
    children: [
      {
        title: "Services",
        path: "/masters/services",
      },
      {
        title: "Packages",
        path: "/masters/packages",
      },
      {
        title: "Lead Sources",
        path: "/masters/lead-sources",
      },
      {
        title: "Lead Status",
        path: "/masters/lead-status",
      },
      {
        title: "Expense Categories",
        path: "/masters/expense-categories",
      },
      {
        title: "Payment Modes",
        path: "/masters/payment-modes",
      },
      {
        title: "Tax Rates",
        path: "/masters/tax-rates",
      },
    ],
  },

  /* =======================================================
     SETTINGS
  ======================================================= */

  {
    title: "Settings",
    icon: <SettingsOutlined />,
    children: [
      {
        title: "Company Setup",
        icon: <BusinessOutlined />,
        path: "/settings/company",
      },
      {
        title: "Financial Years",
        icon: <CalendarMonthOutlined />,
        path: "/settings/financial-years",
      },
      {
        title: "Users",
        icon: <AccountCircleOutlined />,
        path: "/settings/users",
      },
      {
        title: "Roles & Permissions",
        icon: <SettingsOutlined />,
        path: "/settings/roles",
      },
    ],
  },
];

/* =========================================================
   SIDEBAR
========================================================= */

function Sidebar({
  mobileOpen,
  setMobileOpen,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  /* =======================================================
     CHECK CURRENT CHILD
  ======================================================= */

  const isChildActive = (
    children = []
  ) => {
    return children.some(
      (child) =>
        location.pathname === child.path
    );
  };

  /* =======================================================
     CHECK CURRENT PARENT
  ======================================================= */

  const isParentActive = (item) => {
    /* Direct path */

    if (
      item.path &&
      location.pathname === item.path
    ) {
      return true;
    }

    /* Child path */

    if (item.children?.length) {
      return item.children.some(
        (child) =>
          location.pathname === child.path
      );
    }

    return false;
  };

  /* =======================================================
     INITIAL OPEN MENUS
  ======================================================= */

  const getActiveMenus = () => {
    const activeMenus = {};

    menuItems.forEach((item) => {
      if (item.children?.length) {
        activeMenus[item.title] =
          isParentActive(item);
      }
    });

    return activeMenus;
  };

  /* =======================================================
     OPEN MENUS
  ======================================================= */

  const [openMenus, setOpenMenus] =
    useState(() => getActiveMenus());

  /* =======================================================
     ROUTE CHANGE
     
     IMPORTANT:
     This runs whenever the URL changes.
     Therefore refresh/direct navigation works.
  ======================================================= */

  useEffect(() => {
    const activeMenus = getActiveMenus();

    setOpenMenus((previous) => {
      const next = {
        ...previous,
      };

      Object.keys(activeMenus).forEach(
        (menuTitle) => {
          /*
           * Automatically open the menu
           * containing the current route.
           */
          if (activeMenus[menuTitle]) {
            next[menuTitle] = true;
          }
        }
      );

      return next;
    });
  }, [location.pathname]);

  /* =======================================================
     TOGGLE MENU
  ======================================================= */

  const toggleMenu = (title) => {
    setOpenMenus((previous) => ({
      ...previous,
      [title]: !previous[title],
    }));
  };

  /* =======================================================
     NAVIGATE
  ======================================================= */

  const handleNavigate = (path) => {
    if (!path) {
      return;
    }

    navigate(path);

    /*
     * Close mobile drawer after navigation.
     */
    if (setMobileOpen) {
      setMobileOpen(false);
    }
  };

  /* =======================================================
     DRAWER CONTENT
  ======================================================= */

  const drawerContent = (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#FFFFFF",
      }}
    >
      {/* =================================================
          LOGO
      ================================================= */}

      <Box
        sx={{
          height: 82,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
          borderBottom:
            "1px solid #E4E7EC",
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Praneesh Infotech"
          sx={{
            width: "100%",
            maxWidth: 215,
            height: "auto",
            maxHeight: 58,
            objectFit: "contain",
          }}
        />
      </Box>

      {/* =================================================
          MENU
      ================================================= */}

      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          py: 1.5,

          "&::-webkit-scrollbar": {
            width: "5px",
          },

          "&::-webkit-scrollbar-thumb": {
            backgroundColor:
              "#D0D5DD",
            borderRadius: "10px",
          },
        }}
      >
        <List disablePadding>
          {menuItems.map((item) => {
            const hasChildren =
              item.children?.length > 0;

            const parentActive =
              isParentActive(item);

            const childActive =
              hasChildren
                ? isChildActive(
                    item.children
                  )
                : false;

            return (
              <Box
                key={item.title}
              >
                {/* =====================================
                    MAIN MENU
                ====================================== */}

                <ListItemButton
                  onClick={() =>
                    hasChildren
                      ? toggleMenu(
                          item.title
                        )
                      : handleNavigate(
                          item.path
                        )
                  }
                  sx={{
                    mx: 1,
                    mb: 0.5,
                    minHeight: 44,
                    borderRadius:
                      "6px",

                    color:
                      parentActive
                        ? "#008B8B"
                        : "#475467",

                    backgroundColor:
                      parentActive
                        ? "rgba(0,139,139,0.08)"
                        : "transparent",

                    "&:hover": {
                      backgroundColor:
                        "rgba(0,139,139,0.06)",
                      color: "#008B8B",
                    },
                  }}
                >
                  {/* ICON */}

                  <ListItemIcon
                    sx={{
                      minWidth: 38,
                      color: "inherit",
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>

                  {/* TEXT */}

                  <ListItemText
                    primary={
                      item.title
                    }
                    primaryTypographyProps={{
                      fontSize: 14,
                      fontWeight:
                        parentActive
                          ? 700
                          : 500,
                    }}
                  />

                  {/* ARROW */}

                  {hasChildren &&
                    (openMenus[
                      item.title
                    ] ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    ))}
                </ListItemButton>

                {/* =====================================
                    SUB MENU
                ====================================== */}

                {hasChildren && (
                  <Collapse
                    in={
                      openMenus[
                        item.title
                      ]
                    }
                    timeout="auto"
                    unmountOnExit
                  >
                    <List
                      component="div"
                      disablePadding
                    >
                      {item.children.map(
                        (child) => {
                          const active =
                            location.pathname ===
                            child.path;

                          return (
                            <ListItemButton
                              key={
                                child.title
                              }
                              onClick={() =>
                                handleNavigate(
                                  child.path
                                )
                              }
                              sx={{
                                ml: 3,
                                mr: 1,
                                mb: 0.3,
                                minHeight: 38,
                                borderRadius:
                                  "6px",

                                color:
                                  active
                                    ? "#008B8B"
                                    : "#667085",

                                backgroundColor:
                                  active
                                    ? "rgba(0,139,139,0.10)"
                                    : "transparent",

                                borderLeft:
                                  active
                                    ? "3px solid #008B8B"
                                    : "3px solid transparent",

                                "&:hover":
                                  {
                                    backgroundColor:
                                      "rgba(0,139,139,0.06)",
                                    color:
                                      "#008B8B",
                                  },
                              }}
                            >
                              {/* CHILD ICON */}

                              <ListItemIcon
                                sx={{
                                  minWidth: 32,
                                  color:
                                    "inherit",
                                }}
                              >
                                {child.icon || (
                                  <Box
                                    sx={{
                                      width: 5,
                                      height: 5,
                                      borderRadius:
                                        "50%",
                                      backgroundColor:
                                        "currentColor",
                                      ml: 1,
                                    }}
                                  />
                                )}
                              </ListItemIcon>

                              {/* CHILD TEXT */}

                              <ListItemText
                                primary={
                                  child.title
                                }
                                primaryTypographyProps={{
                                  fontSize: 13,
                                  fontWeight:
                                    active
                                      ? 700
                                      : 500,
                                }}
                              />
                            </ListItemButton>
                          );
                        }
                      )}
                    </List>
                  </Collapse>
                )}
              </Box>
            );
          })}
        </List>
      </Box>

      {/* =================================================
          FOOTER
      ================================================= */}

      <Box
        sx={{
          px: 2,
          py: 1.5,
          borderTop:
            "1px solid #E4E7EC",
          backgroundColor:
            "#FFFFFF",
        }}
      >
        <Typography
          sx={{
            fontSize: 11,
            color: "#667085",
            textAlign: "center",
            fontWeight: 500,
          }}
        >
          Praneesh Infotech CRM
        </Typography>

        <Typography
          sx={{
            fontSize: 10,
            color: "#98A2B3",
            textAlign: "center",
            mt: 0.3,
          }}
        >
          Technology | Innovation |
          Growth
        </Typography>

        <Typography
          sx={{
            fontSize: 9,
            color: "#98A2B3",
            textAlign: "center",
            mt: 0.5,
          }}
        >
          v1.0.0
        </Typography>
      </Box>
    </Box>
  );

  /* =======================================================
     RETURN
  ======================================================= */

  return (
    <>
      {/* =================================================
          DESKTOP SIDEBAR
      ================================================= */}

      <Drawer
        variant="permanent"
        sx={{
          display: {
            xs: "none",
            md: "block",
          },

          width: drawerWidth,

          flexShrink: 0,

          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            borderRight:
              "1px solid #E4E7EC",
            backgroundColor:
              "#FFFFFF",
          },
        }}
      >
        {drawerContent}
      </Drawer>

      {/* =================================================
          MOBILE SIDEBAR
      ================================================= */}

      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={() =>
          setMobileOpen(false)
        }
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: {
            xs: "block",
            md: "none",
          },

          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing:
              "border-box",
            backgroundColor:
              "#FFFFFF",
          },
        }}
      >
        {drawerContent}
      </Drawer>
    </>
  );
}

export default Sidebar;